import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser, useSupabaseClient } from "@supabase/auth-helpers-react";
import { Loader2 } from "lucide-react";
import { MainLayout } from "@/components/layout/MainLayout";
import { ToolsSection } from "@/components/tools/ToolsSection";
import { SEOHead } from "@/components/SEOHead";
import { SchemaMarkup } from "@/components/SchemaMarkup";
import { useTools } from "@/hooks/useTools";

const Index = () => {
  const navigate = useNavigate();
  const user = useUser();
  const supabase = useSupabaseClient();
  const [isCheckingRole, setIsCheckingRole] = useState(false);

  const { data: toolsData } = useTools({
    currentPage: 1,
    selectedCategory: "الكل",
    searchQuery: "",
    itemsPerPage: 100,
  });

  useEffect(() => {
    const checkUser = async () => {
      if (!user) return;
      
      try {
        setIsCheckingRole(true);
        const { data: userRole, error } = await supabase
          .from('user_roles')
          .select('role')
          .eq('user_id', user.id)
          .single();

        if (error) {
          console.error("Error checking role:", error);
          return;
        }

        const userRequestedHome = sessionStorage.getItem('userRequestedHome');
        
        if ((userRole?.role === 'admin' || userRole?.role === 'moderator') && !userRequestedHome) {
          navigate("/admin");
          return;
        }
        
        sessionStorage.removeItem('userRequestedHome');
      } catch (error) {
        console.error("Error checking user:", error);
      } finally {
        setIsCheckingRole(false);
      }
    };

    checkUser();
  }, [user, navigate, supabase]);

  if (isCheckingRole) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <>
      <SEOHead />
      <SchemaMarkup tools={toolsData?.tools} />
      <MainLayout>
        <ToolsSection />
      </MainLayout>
    </>
  );
};

export default Index;